import { render, staticRenderFns } from "./8e_doc.vue?vue&type=template&id=0c3f40c4"
import script from "./8e_doc.vue?vue&type=script&lang=js"
export * from "./8e_doc.vue?vue&type=script&lang=js"
import style0 from "./8e_doc.vue?vue&type=style&index=0&id=0c3f40c4&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports